
export function getElementByJsonReference(ref: string, spec: any): ElementReference {
    const referenceParts = ref.split("/");
    if (referenceParts.length !== 3) {
        throw Error(`Invalid reference '${ref}': only #/[definitions|responses|requests]/(ref) references supported`);
    }
    const refType = referenceParts[1];
    const refTarget = referenceParts[2];
    const referencedElem = spec[refType] && spec[refType][refTarget];
    if (!referencedElem) {
        throw Error(`Invalid reference '${ref}': referenced value not found`);
    }
    return { refType: refType, refKey: refTarget, element: referencedElem };
}

export interface ElementReference {
    refType: string;
    refKey: string;
    element: any;
}
